import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'motion/react';

export default function FluoRibbonIntro() {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Prevent scrolling when the component mounts
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    // Keep intro active for a shorter duration
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 1800);

    // Re-enable scrolling halfway through the exit animation (1800ms exit start + 400ms = 2200ms)
    const scrollTimer = setTimeout(() => {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    }, 2000);

    return () => {
      clearTimeout(timer);
      clearTimeout(scrollTimer);
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    };
  }, []);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.8, ease: 'easeInOut' } }}
          className="fixed inset-0 z-[9999] bg-white flex items-center justify-center overflow-hidden cursor-pointer select-none"
        >
          {/* Subtle light dot grid background */}
          <div className="absolute inset-0 bg-[radial-gradient(#00000010_1px,transparent_1px)] [background-size:24px_24px] pointer-events-none" />

          {/* Animated Glowing Orb Background */}
          <motion.div 
            className="absolute w-[400px] h-[400px] sm:w-[600px] sm:h-[600px] pointer-events-none"
            style={{
              background: 'radial-gradient(circle, rgba(70, 1, 250, 0.12) 0%, rgba(70, 1, 250, 0) 70%)'
            }}
            initial={{ scale: 0.1, opacity: 0 }}
            animate={{ scale: 1.2, opacity: 1 }}
            transition={{ duration: 1.5, ease: "easeOut" }}
          />

          {/* Central Name & Role without box */}
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.5, ease: 'easeOut' }}
            className="text-center z-20 space-y-4 px-4 select-none flex flex-col items-center"
          >
            <h1 className="text-4xl sm:text-6xl lg:text-7xl font-black text-black tracking-tight font-display">
              Matteo Petix
            </h1>

            {/* Small animated accent line */}
            <motion.div 
              className="h-[3px] bg-[#ADFE03] rounded-full shadow-[0px_0px_25px_8px_rgba(0,_0,_0,_0.1)]"
              initial={{ width: 0, opacity: 0 }}
              animate={{ width: 80, opacity: 1 }}
              transition={{ duration: 0.7, delay: 0.3, ease: "easeOut" }}
            />

            <p className="text-base sm:text-xl font-bold text-[#4601FA] tracking-wide max-w-lg mx-auto">
              Soluzioni AI, costi bassi, tempi ridotti e qualità garantita.
            </p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

